var map = {
	"./AngularJS.png": 5964,
	"./AntennaTwin1.png": 8819,
	"./AntennaTwin2.png": 6840,
	"./AntennaTwin3.png": 5233,
	"./BI.jpg": 6176,
	"./CPlus-logo.png": 1821,
	"./Comingsoon.jpg": 5651,
	"./EcoSpectrum.png": 1633,
	"./Ecommerce.jpg": 8959,
	"./Ecorvi_Logo.png": 7769,
	"./Ecorvi_WebLogo.jpeg": 9834,
	"./Environment.jpg": 3068,
	"./Fascimal.png": 451,
	"./Fullstack.png": 5534,
	"./Fullstack1.png": 1237,
	"./Healthcare.png": 5366,
	"./IOT/Transformation.jpg": 2395,
	"./IOT/block-chain.jpg": 4201,
	"./IOT/smart-home.jpg": 4457,
	"./Responsive.png": 8897,
	"./Retail.jpg": 3370,
	"./Sass_Logo.png": 5399,
	"./TDGrid.png": 867,
	"./Transformation.jpg": 8148,
	"./block-chain.jpg": 8280,
	"./bootstrap-logo.png": 9745,
	"./city.jpg": 6466,
	"./clock.jpg": 1721,
	"./comingsoon_2.jpg": 2952,
	"./css3-logo.png": 1359,
	"./digitization.jpg": 9070,
	"./django.png": 5850,
	"./html-logo.png": 9958,
	"./java-logo.png": 347,
	"./javascript-logo.png": 5476,
	"./jquery.png": 5109,
	"./logos/AngularJS.png": 6909,
	"./logos/CPlus-logo.png": 3618,
	"./logos/Sass_Logo.png": 5786,
	"./logos/angular-logo-1.png": 7700,
	"./logos/angular-logo.png": 6766,
	"./logos/angularjs-logo.png": 8973,
	"./logos/bootstrap-logo.png": 6910,
	"./logos/css3-logo.png": 9198,
	"./logos/cucumber-logo.png": 6110,
	"./logos/cypress.png": 3127,
	"./logos/django-community-logo.png": 6393,
	"./logos/html-logo.png": 6431,
	"./logos/java-logo-2.png": 2499,
	"./logos/java-logo.png": 1274,
	"./logos/javascript-logo.png": 1449,
	"./logos/jira-logo.png": 518,
	"./logos/jquery.png": 6854,
	"./logos/mongodb-logo.png": 6070,
	"./logos/mysql-logo-1.png": 4432,
	"./logos/nextjs-logo.png": 3596,
	"./logos/node-sass-logo.png": 9877,
	"./logos/nodejs-logo.png": 5281,
	"./logos/oracle-logo.png": 6564,
	"./logos/oracle-logo_1.png": 8916,
	"./logos/php-logo-1.png": 6498,
	"./logos/postgresql-logo.png": 2576,
	"./logos/python-logo.png": 5572,
	"./logos/react-logo.png": 4331,
	"./logos/selenium-py.png": 6962,
	"./logos/selenium.jpg": 6312,
	"./logos/spring-boot-logo.png": 5692,
	"./logos/tailwindcss-logo.png": 6223,
	"./logos/typescript-logo.png": 7761,
	"./logos/wordpress-logo.png": 9819,
	"./mobile.jpg": 6925,
	"./mongodb-logo.png": 4741,
	"./mysql-logo-1.png": 7707,
	"./nodejs-logo.png": 2308,
	"./oracle-logo.png": 8805,
	"./php-logo-1.png": 7429,
	"./postgresql-logo.png": 9189,
	"./python-logo.png": 5653,
	"./react-logo.png": 2264,
	"./smart-home.jpg": 8694,
	"./software.jpg": 3952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6133;